<script   setup>
import {ElButton, ElCol, ElDatePicker, ElDrawer, ElMessage, ElRow, ElText, FormInstance} from "element-plus";
import {computed, reactive, ref, watch} from "vue";
import moment from 'moment';
import { moneyTotal, roundMoney } from '../../../utils/money';

const modell=ref(true);

const ruleFormRef = ref();

const props = defineProps({
    form:Object,
    staytypes:Object,
    roomtypes:Object,
    mealplans:Object

});
const emit = defineEmits(['canceli','addhotel']);
const form=props.form;
const staytypes=props.staytypes;
const datepickervalue=ref(['',''])

const roomtypes=props.roomtypes;

const mealplans=props.mealplans;

const removehotel=(flight)=>{
    emit('removehotel',flight)
}

const rules = reactive({
    name: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    rating: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    city: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    checkIn: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ]

});

const editform=reactive(
    {
        "name":'',
        "rating":'',
        "type":'',
        "address":'',
        "city":'',
        "rooms":[],
        "checkIn":'',
        "checkOut":'',
        "comments":'',
        "pricing":{
            "total":0,
            "adult":0 ,
            "child":0 ,
            "infant":0 ,
        }
    }
)

const updateupricecount = () => {
    editform.pricing.total = moneyTotal(
        form.adults,
        editform.pricing.adult,
        form.childs,
        editform.pricing.child,
        form.infants,
        editform.pricing.infant
    );
};






const submitForm = async (formEl) => {

    if (!formEl) return
    await formEl.validate((valid, fields) => {

        if (valid) {


            let  radts=0;
            let  rchds=0;

            for (let i = 0; i < editform.rooms.length; i++) {
                const room=editform.rooms[i];
                radts += parseInt(room.adt)*parseInt(room.quantity);
                rchds += parseInt(room.chd)*parseInt(room.quantity);
            }



            if(radts==form.adults && rchds==form.childs){
                editform.pricing.adult = roundMoney(editform.pricing.adult);
                editform.pricing.child = roundMoney(editform.pricing.child);
                editform.pricing.infant = roundMoney(editform.pricing.infant);
                editform.pricing.total = roundMoney(editform.pricing.total);
                emit('addhotel',editform)
            }
            else{
                ElMessage({
                    message: 'Adults and Child Count is Incorrect.',
                    type: 'error',
                })
            }


        }
    })
}

watch(
    () => editform.pricing,
    () => {
        updateupricecount();
    },
    { deep:true}
)


watch(
    () => datepickervalue,
    (newValue, oldValue) => {

        editform.checkIn=datepickervalue.value[0];
        editform.checkOut=datepickervalue.value[1];
    }
    ,
    { deep: true }
)


const removeroom=(room)=>{
    const index = editform.rooms.indexOf(room)
    if (index !== -1) {
        editform.rooms.splice(index, 1)
    }
}

const addroom=()=>{
    editform.rooms.push(
        {
            "type": "", "amenities": [], "adt": 0, "chd": 0, "mb": [], "price": 0
        }
    )
}


const disabledDate = (time) => {
    return time.getTime() < moment(String(form.departure_date)).toDate() || time.getTime() > moment(String(form.departure_date)).add(form.nights, 'day').toDate()
}

const defaultDate=ref(moment(String(form.departure_date)).toDate());


const gettypes = () => {
    if(form.includes.hotel && form.includes.cruise){
        return staytypes;
    }
    else if(form.includes.hotel){
        return staytypes.filter(type => {
            return type!="CRUISE";
        });
    }
    else if(form.includes.cruise){
        return ["CRUISE"];
    }
}
</script>

<template>
    <el-dialog
        v-model="modell"
        title="Add Stay"
        width="80%"
        @closed="emit('canceli')"

    >
        <el-form
            ref="ruleFormRef"
            :model="editform"
            status-icon
            label-width="auto"
            class="demo-ruleForm"
            label-position="top"
            size="small"
            :rules="rules"

        >

            <el-row :gutter="20">
                <el-col :span="4">
                    <el-form-item label="Type"  prop="type"
                                  :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-select
                            v-model="editform.type"
                            placeholder="Type"
                            style="width: 100%"
                            allow-create
                            filterable
                        >
                            <el-option
                                v-for="item in gettypes()"
                                :key="item"
                                :label="item"
                                :value="item"
                            />

                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8" >
                    <el-form-item label="Name" prop="name">
                        <el-input v-model="editform.name"  placeholder="Name" />
                    </el-form-item>

                </el-col>
                <el-col :span="8" >
                    <el-form-item label="Address" prop="address">
                        <el-input v-model="editform.address"  placeholder="Address" />
                    </el-form-item>

                </el-col>
                <el-col :span="4" >
                    <el-form-item label="City" prop="city" >
                        <el-input v-model="editform.city"  placeholder="City" />
                    </el-form-item>

                </el-col>

            </el-row>
            <el-row :gutter="20">
                <el-col :span="4" >
                    <el-form-item label="Ratings" prop="rating">
                        <el-select
                            v-model="editform.rating"
                            placeholder="Select Rating"
                            style="width: 100%"
                        >
                            <el-option
                                :key="5"
                                label="5 Star"
                                :value="5"
                            />
                            <el-option
                                :key="4"
                                label="4 Star"
                                :value="4"
                            />
                            <el-option
                                :key="3"
                                label="3 Star"
                                :value="3"
                            />
                            <el-option
                                :key="2"
                                label="2 Star"
                                :value="2"
                            />
                            <el-option
                                :key="1"
                                label="1 Star"
                                :value="1"
                            />
                        </el-select>
                    </el-form-item>

                </el-col>
                <el-col :span="6" >
                    <el-form-item label="Dates" prop="checkIn">
                        <el-date-picker
                            v-model="datepickervalue"
                            type="daterange"
                            range-separator="To"
                            start-placeholder="Check-In"
                            end-placeholder="Check-Out"
                            format="DD/MMM/YYYY"
                            value-format="YYYY-MM-DD"
                            :clearable="false"
                            :disabled-date="disabledDate"
                            :default-value="defaultDate"
                        />

                    </el-form-item>

                </el-col>

            </el-row>
            <el-row :gutter="20">
                <el-col :span="2" >
                    <el-form-item label="Adults" >
                        <el-input v-model="form.adults"  placeholder="Adults" disabled/>
                    </el-form-item>

                </el-col>
                <el-col :span="3" >
                    <el-form-item label="Price (Per Adult)" prop="pricing.adult" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="editform.pricing.adult"  placeholder="Price (Per Adult)" />
                    </el-form-item>

                </el-col>

                <el-col :span="2" v-if="form.childs>0">
                    <el-form-item label="Childs" >
                        <el-input v-model="form.childs"  placeholder="Childs" disabled/>
                    </el-form-item>

                </el-col>
                <el-col :span="3" v-if="form.childs>0">
                    <el-form-item label="Price (Per Child)" prop="pricing.child" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="editform.pricing.child"  placeholder="Price (Per Child)" />
                    </el-form-item>

                </el-col>
                <el-col :span="2" v-if="form.infants>0">
                    <el-form-item label="Infants" >
                        <el-input v-model="form.infants"  placeholder="Childs" disabled/>
                    </el-form-item>

                </el-col>
                <el-col :span="3" v-if="form.infants>0">
                    <el-form-item label="Price (Per Infant)" prop="pricing.infant" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="editform.pricing.infant"  placeholder="Price (Per Infant)" />
                    </el-form-item>

                </el-col>

                <el-col :span="3" >
                    <el-form-item label="Total Price" >
                        <el-input v-model="editform.pricing.total"  placeholder="Total Price" disabled/>
                    </el-form-item>

                </el-col>

            </el-row>

            <el-row :gutter="20">
                <el-col :span="24">
                    <el-text size="large" tag="b">Rooms</el-text>&nbsp;&nbsp;
                    <el-button type="primary" size="small" @click="addroom()" >Add Room</el-button>
                </el-col>
                <el-col :span="24" v-for="(room,index) in editform.rooms">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <el-form-item label="Room Type"  :prop="'rooms.' + index + '.type'"
                                          :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                <el-select
                                    v-model="room.type"
                                    placeholder="Room Type"
                                    style="width: 100%"
                                    allow-create
                                    filterable
                                >
                                    <el-option
                                        v-for="item in roomtypes"
                                        :key="item"
                                        :label="item"
                                        :value="item"
                                    />

                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3" >
                            <el-form-item label="Quantity" :prop="'rooms.' + index + '.quantity'"
                                          :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                <el-input v-model="room.quantity" type="number"  placeholder="Quantity" />
                            </el-form-item>

                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="Meal Plan" :prop="'rooms.' + index + '.mb'"
                                          :rules="{
                                                        type: 'array',
                                                        required: true,
                                                        min: 1,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                <el-select
                                    v-model="room.mb"
                                    placeholder="Meal Plan"
                                    multiple
                                    filterable
                                    collapse-tags
                                    collapse-tags-tooltip
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="item in mealplans"
                                        :key="item"
                                        :label="item"
                                        :value="item"
                                    />

                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3" >
                            <el-form-item label="Adults" :prop="'rooms.' + index + '.adt'"
                                          :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                <el-input v-model="room.adt"  placeholder="Adults" />
                            </el-form-item>

                        </el-col>
                        <el-col :span="3" >
                            <el-form-item label="Child" :prop="'rooms.' + index + '.chd'"
                                          :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                <el-input v-model="room.chd"  placeholder="Child" />
                            </el-form-item>

                        </el-col>
                        <el-col :span="3" >
                            <el-form-item label="." >
                                <el-button type="danger" size="small" @click="removeroom(room)" >Remove</el-button>
                            </el-form-item>


                        </el-col>

                    </el-row>
                </el-col>

            </el-row>

            <el-row :gutter="20">
                <el-col :span="24" >
                    <el-form-item label="Comments" >
                        <el-input type="textarea" v-model="editform.comments"  placeholder="Comments" />
                    </el-form-item>
                </el-col>

            </el-row>
        </el-form>


        <template #footer>
            <div class="dialog-footer">
                <el-button @click="emit('canceli')">Cancel</el-button>
                <el-button type="primary" @click="submitForm(ruleFormRef)">
                    Save
                </el-button>
            </div>
        </template>

    </el-dialog>
</template>

<style scoped>

</style>
